enum AppRoutes {
  ADMIN_DASHBOARD_PATH = 'admin-dashboard',
  AUTH_PATH = 'auth',
  INVITES_PATH = 'invites/confirm',
  ONBOARDING_PATH = 'onboarding',
}

export default AppRoutes;
